import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'LoginPage',
        component: () => import('@/components/LoginPage.vue'),
    },
    {
        path: '/welcomepage',
        name: 'WelcomePage',
        component: () => import('@/components/WelcomePage.vue'),
        props: (route) => ({
            name: route.query.name,
            email: route.query.email,
            token: route.query.token,
        }),
    },
    {
        path: '/formpage',
        name: 'FormPage',
        component: () => import('@/components/FormPage.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/selectsheetpage',
        name: 'SelectSheetPage',
        component: () => import('@/components/SelectSheetPage.vue'),
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        let isLoggedIn = sessionStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'false' || isLoggedIn === null) {
            next({
                name: 'LoginPage',
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
